import { Container, DownloadFile, Heading6 } from "shared/components";

import styles from "./Content074.module.scss";

export const Content062 = ({ payload }) => {
  const attachments = payload?.attachments ?? [];

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.files}>
          {attachments.map((attachment) => (
            <div className={styles.file} key={attachment.id}>
              <Heading6 className={styles.title}>{attachment.title}</Heading6>
              <DownloadFile
                file={attachment.file}
                label={attachment.attachmentButtonText}
              />
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Content062;
